export default {
    path: ":alias/brands/artshow",
    component: resolve => require(["@/views/artshow"], resolve),
    children: [
      {
        path: "list",
        component: resolve => require(["@/views/artshow/list"], resolve)
      },
      {
        path: "list/items",
        component: resolve => require(["@/views/artshow/list/items"], resolve)
      }
    ]
  };
  